<template>
  <div class="userguide">
    <div class="guide">
      <div class="guide_w">
        <div class="tit">
          Hi DO community<br />
          members!
        </div>
      </div>
    </div>
    <div class="box">
      <div class="boxtit">
        This is a guide for you to explore<br />
        the DO network. You will know<br />
        how to earn from DO, and how to<br />
        get familiar with DO, and how to<br />
        participate in DO.
      </div>
      <div class="boxtit1">
        No matter if you know about technology,<br />
        no matter if you are a newcomer or a<br />
        master, this article will help!
      </div>
      <div class="boxtit3">
        <div class="tits">Now, let&#39;s start our journey</div>
        <img src="../../../assets/pc/user/down.png" />
      </div>
    </div>
    <div class="guidenum">
      <div class="num">No 1</div>
      <div class="numtit">Explore Sunny Wallet</div>
    </div>

    <div class="guide1">
      <div class="guide1-w">
        <div class="guideul">
          <div class="guideli" style="padding-bottom: 0px">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Create your wallet</div>
            </div>
            <div class="litit2">
              Sunny Wallet is the main entrance of DO <br />network, also your
              starting point.If you<br />
              are a newcomer, after you download the<br />
              latest version and install, create a new<br />
              wallet.
            </div>
            <div class="litit3">
              Backup your Mnemonics, remember <br />not to tell anyone
            </div>
            <img src="../../../assets/pc/user/1a.png" />
          </div>
          <div class="guideli" style="padding-bottom: 0px">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Get DO in your wallet</div>
            </div>
            <div class="litit2">
              After creating your wallet, you can see <br />your assets. If you
              don&#39;t have any DO yet,<br />
              you can buy some at Hotcoin and <br />withdraw to your wallet, or
              follow our<br />
              social media and participate in our<br />
              airdrop campaigns to get some.
            </div>

            <img
              src="../../../assets/pc/user/1b.png"
              style="margin-top: 40px"
            />
          </div>
          <div class="guideli">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Try investing</div>
            </div>
            <div class="litit2">
              Click “Invest” in your Sunny wallet,<br />
              choose a node that hasn&#39;t reached 100% <br />yet to invest in.
            </div>
            <div class="litit3">
              Then you can enjoy an APY up to<br />
              10%! It is that easy!
            </div>
            <img src="../../../assets/pc/user/1c.png" />
          </div>
        </div>
        <div class="guidenum">
          <div class="num">No 2</div>
          <div class="numtit">Explore DO chain</div>
        </div>
        <div class="guidetit">
          DO has a strong explorer to make it possible for<br />
          everyone to check all the public data on chain. It is
          <br />comprehensive and easy to use.
        </div>
        <div class="guideul">
          <div class="guideli" style="margin-top: 33px">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Total view</div>
            </div>
            <div class="litit2">
              In the official website, click“Explore DO <br />Network”-“DO
              EXPLORER”on the right top <br />corner, then you can enter the
              DO<br />
              explorer, and you can see everything on<br />
              the DO chain.
            </div>
            <!-- <div class="litit3" style="width: 403px">
              Backup your Mnemonics, remember not to tell anyone
            </div> -->
            <img src="../../../assets/m/user/u1.png" class="img1" />
          </div>
          <div class="guideli">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Check your address</div>
            </div>
            <div class="litit2">
              You can enter your address (or any <br />other address) in the
              search bar, thus<br />
              you can check the assets, the<br />
              transactions and other information <br />about this address.
            </div>

            <img src="../../../assets/m/user/u2.png" class="img2" />
          </div>
          <div class="guideli">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Check the validators</div>
            </div>
            <div class="litit2">
              Click “Validators” on the right top area<br />
              and you can see the validator list. You<br />
              can check the informations of each <br />validator to decide which
              validator to<br />
              delegate to.
            </div>

            <img src="../../../assets/m/user/u3.png" class="img3" />
          </div>
          <div class="guideli">
            <div class="litit1">
              <div class="step">4</div>
              <div class="steptit">Create your own coin</div>
            </div>
            <div class="litit2">
              Do you want to create your own coin on<br />
              DO network? It is so easy! Click “More”-”<br />Contract
              Deployment”-“No-Code <br />Contract Deployment”.
            </div>

            <img src="../../../assets/m/user/u4.png" class="img4" />
            <div class="litit2a">
              Then enter the basic information of your<br />
              coin, and confirm.
            </div>
            <img src="../../../assets/m/user/u5.png" class="img5" />
            <div class="litit3" style="width: 305px">
              Thus you now have your own coin!<br />
              Try it!
            </div>
          </div>
        </div>
        <div class="guidenum">
          <div class="num">No 3</div>
          <div class="numtit">Explore DO community</div>
        </div>
        <div class="guidetit">
          DO has a strong community where you can <br />communicate with DO
          community members from all<br />
          over the world.
        </div>
        <div class="litit3a">
          Click “Community” to check on the<br />
          right top corner of the main page of<br />
          the official website.
        </div>
        <div class="guideul">
          <div class="guideli">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Twitter/X</div>
            </div>
            <div class="litit2">
              You can find all official links of DO and <br />pay attention to
              our pinned tweet to <br />follow the latest campaign.
            </div>
            <!-- <div class="litit3" style="width: 403px">
              Backup your Mnemonics, remember not to tell anyone
            </div> -->
            <img src="../../../assets/m/user/u6.png" class="img3a1" />
          </div>
          <div class="guideli" style="padding-bottom: 0px">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Discord</div>
            </div>
            <div class="litit2b">
              The discord is divided into different <br />channels and you can
              easily find the <br />information you want.
            </div>

            <img src="../../../assets/m/user/u7.png" class="img3a2" />
          </div>
          <div class="guidelias">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Galxe/Zealy</div>
            </div>
            <div class="litit2">
              We keep holding campaigns on these<br />
              task platforms and keep an eye on it!
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="guibg">
      <div class="bgtit">
        So that&#39;s a brief guide for you <br />to explore the DO ecology!
      </div>
      <div class="bgcon">
        Let&#39;s move on and you will find more <br />surprises!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.userguide {
  width: 100%;
  overflow: hidden;
  background: #f2f5f9;

  .guide {
    background: url("../../../assets/m/user/ubg.png") no-repeat;
    height: 408px;
    background-size: cover;
    .guide_w {
      width: 650px;
      margin: 0 auto;
      padding-top: 220px;
      .tit {
        height: 165px;
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 64px;
        color: #000000;
        line-height: 83px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
  .box {
    width: 650px;
    height: 643px;
    margin: 0 auto;
    background: linear-gradient(270deg, #e4efff 0%, #e8ddf9 100%);
    border-radius: 15px 15px 15px 15px;
    padding-top: 40px;
    margin-top: 32px;
    .boxtit {
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #143d83;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      //padding-top: 40px;
    }
    .boxtit1 {
      width: 550px;
      height: 129px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 27px;
      color: #61666b;
      line-height: 43px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 0 auto;
      margin-top: 32px;
    }
    .boxtit3 {
      width: 550px;
      height: 90px;
      background: #4573e7;
      border-radius: 7px 7px 7px 7px;

      display: flex;
      margin-top: 47px;
      margin-left: 50px;
      .tits {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 27px;
        color: #ffffff;
        line-height: 90px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 56px;
      }
      img {
        width: 44px;
        height: 44px;
        margin-top: 23px;
        margin-left: 17px;
      }
    }
  }
  .guidenum {
    .num {
      width: 85px;
      height: 44px;
      background: rgba(69, 115, 231, 0.3);
      border-radius: 39px 39px 39px 39px;
      font-family: Poppins, Poppins;
      font-weight: 700;
      font-size: 24px;
      color: #4573e7;
      line-height: 44px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-left: 331px;
      margin-top: 80px;
    }
    .numtit {
      height: 55px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #1a1a2c;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 19px;
      margin-bottom: 33px;
    }
  }
  .guide1 {
    // padding-bottom: 80px;
    .guide1-w {
      width: 650px;
      margin: 0 auto;
      .guideul {
        .guideli {
          width: 650px;
          // height: 564px;
          background: #ffffff;
          border-radius: 15px 15px 15px 15px;
          padding-top: 30px;
          margin-bottom: 30px;
          padding-bottom: 28px;
          .litit1 {
            display: flex;
            margin-left: 40px;
            align-content: center;
            justify-content: center;

            .step {
              width: 29px;
              height: 29px;
              background: #1a1a2c;
              border-radius: 193px 193px 193px 193px;

              line-height: 29px;
              font-family: Poppins, Poppins;
              font-weight: 800;
              font-size: 23px;
              color: #ffffff;

              text-align: center;
              font-style: normal;
              text-transform: none;
              margin-top: 12px;
              margin-right: 9px;
            }
            .steptit {
              height: 55px;
              font-family: Poppins, Poppins;
              font-weight: 600;
              font-size: 28px;
              color: #1a1a2c;
              line-height: 54px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .litit2 {
            // width: 554px;
            height: 215px;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 27px;
            color: #61666b;
            line-height: 43px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin: 0 auto;
            margin-top: 14px;
            word-spacing: -2px;
          }
          .litit2a {
            // width: 554px;

            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 27px;
            color: #61666b;
            line-height: 43px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin: 0 auto;
            margin-top: 80px;
            margin-bottom: 35px;
            word-spacing: -2px;
          }
          .litit2b {
            // width: 554px;

            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 27px;
            color: #61666b;
            line-height: 43px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin: 0 auto;
            margin-top: 14px;
            margin-bottom: 33px;
            word-spacing: -2px;
          }
          .litit3 {
            width: 550px;
            height: 117px;
            background: rgba(69, 115, 231, 0.15);
            border-radius: 7px 7px 7px 7px;
            margin: 0 auto;
            margin-top: 24px;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 27px;
            color: #4573e7;
            line-height: 43px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            padding-top: 16px;
          }
          img {
            width: 437px;
            height: 518x;
            margin-left: 107px;
            margin-top: 40px;
          }
          .img1 {
            width: 650px;
            height: 263px;
            margin: 0 auto;
            margin-top: 40px;
          }
          .img2 {
            width: 640px;
            height: 269px;
            margin: 0 auto;
            margin-top: 40px;
          }
          .img3 {
            width: 650px;
            height: 293px;
            margin: 0 auto;
            margin-top: 40px;
          }
          .img4 {
            width: 650px;
            height: 192px;
            margin: 0 auto;
            // margin-top: 40px;
          }
          .img5 {
            width: 650px;
            height: 332px;
            margin: 0 auto;
          }
          .img3a1 {
            width: 651px;
            height: 495px;
            margin: 0 auto;
          }

          .img3a2 {
            width: 650px;
            height: 386px;
            margin: 0 auto;
          }
        }
        .guidelias {
          width: 650px;
          margin: 0 auto;
          height: 243px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          margin-bottom: 80px;
          .litit1 {
            display: flex;
            margin-left: 40px;
            align-content: center;
            justify-content: center;

            .step {
              width: 29px;
              height: 29px;
              background: #1a1a2c;
              border-radius: 193px 193px 193px 193px;

              line-height: 29px;
              font-family: Poppins, Poppins;
              font-weight: 800;
              font-size: 23px;
              color: #ffffff;

              text-align: center;
              font-style: normal;
              text-transform: none;
              margin-top: 40px;
              margin-right: 9px;
            }
            .steptit {
              margin-top: 28px;
              height: 55px;
              font-family: Poppins, Poppins;
              font-weight: 600;
              font-size: 28px;
              color: #1a1a2c;
              line-height: 54px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .litit2 {
            // width: 554px;

            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 27px;
            color: #61666b;
            line-height: 43px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin: 0 auto;
            margin-top: 14px;
            word-spacing: -2px;
          }
        }
      }
      .guidenum {
        .num {
          width: 85px;
          height: 44px;
          background: rgba(69, 115, 231, 0.3);
          border-radius: 39px 39px 39px 39px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 24px;
          color: #4573e7;
          line-height: 44px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-left: 281px;
          margin-top: 80px;
        }
        .numtit {
          height: 55px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 19px;
        }
      }
      .guidetit {
        width: 650px;
        height: 129px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 24px;
        color: #61666b;
        line-height: 43px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .litit3a {
        width: 550px;
        height: 161px;
        background: rgba(69, 115, 231, 0.15);
        border-radius: 7px 7px 7px 7px;
        margin: 0 auto;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 27px;
        color: #4573e7;
        line-height: 43px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        padding-top: 16px;
        margin-bottom: 27px;
      }
    }
  }
  .guibg {
    background: url("../../../assets/pc/user/bg2.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    height: 321px;
    width: 750px;
    margin-bottom: 107px;
    // background-size: cover;
    .bgtit {
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #4573e7;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      padding-top: 54px;
    }
    .bgcon {
      height: 92px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #4573e7;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 13px;
    }
  }
}
</style>
